import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './styles.css';
import { Well } from 'react-bootstrap';
import GrayPanel from '../../components/GrayPanel/GrayPanel';

class ConfirmAccount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: this.props.userData,
      token: this.props.token,
      status: 'pending',
    };
  }

  componentDidMount = () => {
    const url = `${process.env.API_URL}/user/activate_account`;

   fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: this.state.token,
      }),
    })
    .then(async r => {
      const data = await r.json();

      let activationStatus = 'pending';

      if (r.status === 200) {
        activationStatus = 'success';

      } else if (r.status === 400) {

        switch (data.code) {

          case 'MISSING_TOKEN':
            activationStatus = 'missing';
            break;

          case 'INVALID_TOKEN':
            activationStatus = 'invalid';
            break;

          case 'ACCOUNT_ALREADY_ACTIVATED':
            activationStatus = 'alreadyActivated';
            break;

          default:
            activationStatus = 'error';
        }

      } else if (r.status === 404) {

        activationStatus = 'userNotFound';

      } else {

        activationStatus = 'error';
      }

      this.setState({
        status: activationStatus,
      });
    })
    .catch(() => {
      this.setState({
        status: 'error',
      });
    });
  };

  getStatusMessage = (status) => {
    switch (status) {
      case 'pending':
        return 'Trwa aktywacja konta...';

      case 'success':
        return `Konto zostało pomyślnie aktywowane! Możesz teraz ${this.state.user ? 'w pełni korzystać z' : 'zalogować się do'} portalu e-usług E-SPDP.`;

      case 'missing':
        return 'Nie podano tokenu aktywacyjnego. Proszę użyć linku z wiadomości e-mail, która została wysłana po rejestracji.';

      case 'invalid':
        return 'Podany token jest nieprawidłowy lub wygasł. Proszę użyć linku z wiadomości e-mail, która została wysłana po rejestracji.';

      case 'alreadyActivated':
        return 'Konto zostało już aktywowane. Zaloguj się ponownie do portalu.';

      case 'userNotFound':
        return 'Nie znaleziono użytkownika związanego z tym tokenem. Proszę użyć linku z wiadomości e-mail, która została wysłana po rejestracji.';

      case 'error':
        return 'Wystąpił błąd podczas aktywacji konta. Proszę spróbować ponownie później.';

      default:
        return '';
    }
  };


  render() {
    return (
      <div>
        <div className={s.mainContainer} style={{ display: 'block' }}>
          <h4 className={s.mainTitle}>Portal e-usług E-SPDP - aktywacja konta</h4>
          <div style={{ textAlign: 'center', marginBottom: '20px', height: '50px' }}>
            {this.getStatusMessage(this.state.status)}
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(s)(ConfirmAccount);



// WEBPACK FOOTER //
// src/routes/ConfirmAccount/index.js